import { render, staticRenderFns } from "./BizTaskNotificationModal.vue?vue&type=template&id=207055d2&scoped=true&"
import script from "./BizTaskNotificationModal.vue?vue&type=script&lang=js&"
export * from "./BizTaskNotificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207055d2",
  null
  
)

export default component.exports